var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "#4CDA64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5V8.96226H13.7387C15.5036 8.96226 15.5571 10.9698 13.7387 10.9698H8.7649C7.35298 11.1811 7 12.2906 7 12.8189V19C10.2089 18.8732 11.0111 16.2352 11.0111 14.9321H14.4875C20.5309 14.3509 20.4774 5.47547 14.4875 5H7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanaIcon);
export default __webpack_public_path__ + "static/media/pana-icon.d0e4100c694dda349abcedfdd288422d.svg";
export { ForwardRef as ReactComponent };